export const validId = (toCheck: string | null | undefined) => {
  // /^[a-zA-Z0-9] with underscore and dash allowed
  return validString(toCheck, /^[a-zA-Z0-9_-]+$/, 1, 36);
}

export const validIdList = (toCheck: string[] | null | undefined) => {
  if (toCheck == null) {
    console.log("missing parameter");
    return {
      valid: false,
      message: "Missing parameter"
    }
  }

  // check if array
  if (!Array.isArray(toCheck)) {
    console.log("parameter is not an array");
    return {
      valid: false,
      message: "Parameter is not an array"
    }
  }

  const uniqueIds: string[] = []
  for (let i = 0; i < toCheck.length; i++) {
    if (!validId(toCheck[i])) {
      console.log("invalid id: " + toCheck[i]);
      return {
        valid: false,
        message: `Invalid id: ${toCheck[i]}`
      }
    }

    if (uniqueIds.includes(toCheck[i])) {
      console.log("duplicate id: " + toCheck[i]);
      return {
        valid: false,
        message: `Duplicate id: ${toCheck[i]}`
      }
    }

    uniqueIds.push(toCheck[i]);
  }

  return {
    valid: true,
    message: "valid id list"
  }
}

export const validField = (toCheck: string | null | undefined, min?: number, max?: number) => {

  if (!min) {
    min = 0
  }

  if (!max) {
    max = 24
  }

  return validString(toCheck, /^[a-zA-Z0-9:_ -]+$/, min, max);
}

export const validColor = (toCheck: string | null | undefined) => {
  return validString(toCheck, /^#[0-9A-Fa-f]{6}$/, 7, 7);
}

const validString = (toCheck: string | null | undefined, regex: RegExp, min?: number, max?: number) => {

  if (toCheck == undefined) {
    console.log("missing parameter");
    return false;
  }

  if (toCheck == null) {
    console.log("missing parameter");
    return false;
  }

  if (min && toCheck.length < min) {
    console.log(`string is too short: ${toCheck.length} < ${min}`);
    return false;
  }

  if (max && toCheck.length > max) {
    console.log(`string is too long: ${toCheck.length} > ${max}`);
    return false;
  }

  return regex.test(toCheck);
}

export const listsMatch = (first?: string[], second?: string[]): boolean => {
  if (!first && !second) {
    return true;
  }

  if (!first || !second) {
    return false;
  }

  if (first.length !== second.length) {
    return false;
  }

  first.sort();
  second.sort();

  for (let i = 0; i < first.length; i++) {
    if (first[i] !== second[i]) {
      return false;
    }
  }

  return true;
}